/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */

const isWebColor = (color: string): boolean =>
  color === "currentcolor" ||
  color === "currentColor" ||
  color === "inherit" ||
  color.indexOf("var(") === 0

export default isWebColor
